import React, { useContext, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import {
  parseCategories,
  calcTotalVariable,
  findCategoryByName,
  calTotal,
} from "../../utils/CategoryUtils";
import useLocalStorage from "../../Hooks/useLocalStorage";

const CATEGORIES_CIQ = ["TOT", "ARM", "LEG", "GD", "TD", "KD", "SUB"];

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
const Row = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: 1em;
  font-weight: 100;
  align-items: center;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  overflow-y: auto;
  border-spacing: 0;
  color: white;
  th {
    padding: 10px;
    text-align: center;
    font-size: 16px;
  }
  td {
    padding: 10px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    width: 80px;
    border-bottom: 1px solid black;
    font-size: 18px;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 700;
  font-size: 0.8em;
  text-transform: uppercase;
  text-align: left;
`;

const TR = styled.tr`
  background-color: ${(props) =>
    props.title ? "#343e4e" : props.odd ? "#222e42" : ""};
  > td:nth-child(2),
  > td:nth-child(4),
  > td:nth-child(6) {
    background-color: ${(props) => (!props.title ? "#932c2c" : "")};
  }
  > td:nth-child(3),
  > td:nth-child(5),
  > td:nth-child(7) {
    background-color: ${(props) => (!props.title ? "#222274" : "")};
  }
`;

const TRFC = styled.tr`
  background-color: ${(props) =>
    props.title ? "#343e4e" : props.odd ? "#222e42" : ""};
  > td:nth-child(1),
  > td:nth-child(4),
  > td:nth-child(6) {
    background-color: ${(props) => (!props.title ? "#932c2c" : "")};
  }
  > td:nth-child(3),
  > td:nth-child(5),
  > td:nth-child(7) {
    background-color: ${(props) => (!props.title ? "#222274" : "")};
  }
`;
export default function NonStrikeStats({ game }) {
  const rawCategories = game?.competition?.categories;
  const fightcardstorage = useLocalStorage("hyper-combat-fightcard")
  const fightcard = fightcardstorage[0].cachedGames
  const knockdownCat = useMemo(() => findCategoryByName(rawCategories, "knockdown"), [rawCategories]);
  const takedownCat = useMemo(() => findCategoryByName(rawCategories, "takedown"), [rawCategories]);
  const submissionCat = useMemo(() => findCategoryByName(rawCategories, "submission"), [rawCategories]);

  useEffect(() => {
    const activeId = game?._id
    const container = document.getElementById("scroll-container");
    const targetrow = document.getElementById(activeId);

    if (container && targetrow) {
      const targetoffset = targetrow.offsetTop - container.offsetTop
      container.scrollTo({
        behavior: "smooth",
        top: targetoffset
      })
    }
  }, [game?._id])

  let period = useMemo(() => {
    let p = [...(game?.live_data?.periods || [])].sort(
      (a, b) => b.number - a.number
    )[0];

    return p;
  }, [game]);

  function calcStat({ variable, stats, round }) {
    return calcTotalVariable({ variable, stats, round });
  }

  function calcAttempts({ cat, stats, round }) {
    if (!cat) return 0;
    return calTotal({ stat_1: cat.landed, stat_2: cat.missed, stats, round });
  }
  if (game?.competition?.competition_type === "bellator" || game?.competition?.competition_type === "pfl europe") {
  return (
    game && (
      <Main>
        <Table>
          <thead>
            <tr>
              <TH></TH>
              <TH colSpan={2}>Current Round (Match Totals)</TH>
            </tr>
            <tr>
              <TH>NON-STRIKE STATS</TH>
              <TH>{game?.home_fighter?.last_name}</TH>
              <TH>{game?.away_fighter?.last_name}</TH>
            </tr>
          </thead>
          <tbody>
            <TR odd={true}>
              <td>Knockdowns</td>
              <td>
                {calcStat({
                  variable: knockdownCat?.landed,
                  stats: game?.home_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcStat({
                  variable: knockdownCat?.landed,
                  stats: game?.home_player_stats,
                })}
                )
              </td>
              <td>
                {calcStat({
                  variable: knockdownCat?.landed,
                  stats: game?.away_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcStat({
                  variable: knockdownCat?.landed,
                  stats: game?.away_player_stats,
                })}
                )
              </td>
            </TR>
            <TR>
              <td>Takedown Attempts</td>
              <td>
                {calcAttempts({
                  cat: takedownCat,
                  stats: game?.home_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcAttempts({
                  cat: takedownCat,
                  stats: game?.home_player_stats,
                })}
                )
              </td>
              <td>
                {calcAttempts({
                  cat: takedownCat,
                  stats: game?.away_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcAttempts({
                  cat: takedownCat,
                  stats: game?.away_player_stats,
                })}
                )
              </td>
            </TR>
            <TR odd={true}>
              <td>Takedowns</td>
              <td>
                {calcStat({
                  variable: takedownCat?.landed,
                  stats: game?.home_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcStat({
                  variable: takedownCat?.landed,
                  stats: game?.home_player_stats,
                })}
                )
              </td>
              <td>
                {calcStat({
                  variable: takedownCat?.landed,
                  stats: game?.away_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcStat({
                  variable: takedownCat?.landed,
                  stats: game?.away_player_stats,
                })}
                )
              </td>
            </TR>
            <TR>
              <td>Submission Attempts</td>
              <td>
                {calcAttempts({
                  cat: submissionCat,
                  stats: game?.home_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcAttempts({
                  cat: submissionCat,
                  stats: game?.home_player_stats,
                })}
                )
              </td>
              <td>
                {calcAttempts({
                  cat: submissionCat,
                  stats: game?.away_player_stats,
                  round: period?.number,
                })}{" "}
                (
                {calcAttempts({
                  cat: submissionCat,
                  stats: game?.away_player_stats,
                })}
                )
              </td>
            </TR>
            {/* <TR odd={true}>
              <td>Clinch Time</td>
              <td style={{ backgroundColor: "#181d25" }} colSpan={2}>
                {game?.ciq_stats?.CL_time}
              </td>
            </TR>
            <TR odd={true}>
              <td>Standing Time</td>
              <td style={{ backgroundColor: "#181d25" }} colSpan={2}>
                {game?.ciq_stats?.GD_time}
              </td>
            </TR> */}
          </tbody>
        </Table>
      </Main>
    )
  );
} else if (game?.competition?.competition_type === "Total Kombat" || game?.competition?.competition_type === "Sky Boxing") {
  return (
    game && (
      <Main style={{maxHeight: "70vh", overflowY: "auto", position:"relative", scrollbarWidth:"none"}}
      id="scroll-container"
      >
      <Table>
      <thead>
        <tr>
          <TH colSpan={3}>
            FIGHT CARD
          </TH>
        </tr>
      </thead>
      {fightcard?.map((item, index) => {
        let current = (item?._id === game?._id ?
        game :
        item)
        return (
          <tbody key={index}
          id={item?._id}
          style={{ outlineOffset: "-2px",
          outline: (item?._id === game?._id) ?
        "2px solid #0adb93" 
        : "none",
          }}>
          <TH colSpan={3}>
            Fight {index + 1} {item?.title}
          </TH>
          <TRFC>
            <td style={{ width:"33%",
        borderBottom: ( current?.completed === 1 ) ?
        "2px solid #0adb93" 
        : "none",
            }}>
            {item?.home_fighter?.first_name} {item?.home_fighter?.last_name}
            </td>
            <td style={{ width:"33%",}}>
            <span>
            {current?.completed === 2 ?
            "BEAT BY" 
            : current?.completed === 1 ?
            "BEAT" 
            : 
            "v" 
            }
            </span>
            </td>
            <td style={{ width:"33%",
        borderBottom: ( current?.completed === 2 ) ?
        "2px solid #0adb93" 
        : "none",
            }}>
            {item?.away_fighter?.first_name} {item?.away_fighter?.last_name}
            </td>
            </TRFC>
      {(current?.completed > 0) &&
            <TH title={true} style={{backgroundColor:( current?.completed === 1 ) ?
        "#702121ff" :
        ( current?.completed === 2 ) ?
        "#1a1a58ff"
        : "#222e42",
        borderBottom: "2px solid #222e42"
        }} colSpan={3}>
              Winner By  {current?.winnerby}
              </TH>
      }
          </tbody>
        )
      })}
      </Table>
      </Main>
    )
  )
}
}
